import React from "react";
import { sanitiseString, concatStringFromClassesArrayList } from "../../Utils";
import { NavLink } from "react-router-dom";

export interface Props {
  id: string;
  classes?: string;
  hiddenTitle?: string;
  hiddenTitleId?: string;
  sections: Section[];
  dataTestId: string;
}

export interface Section {
  linkComponent: typeof NavLink;
  title: string;
  url: string;
  isActive: boolean;
}

export const SectionNavigation = (props: Props) => {
  const sanitisedId = sanitiseString(props.id);
  const sanitisedHiddenTitleId =
    sanitiseString(props.hiddenTitleId) || "section-menu-nav-title";
  const sanitisedDataTestId = sanitiseString(props.dataTestId);

  const sectionNavigationClassList = {
    defaultClass: "ons-section-nav",
    optionalClasses: props.classes && [props.classes],
  };
  const sectionNavigationClassName = concatStringFromClassesArrayList(
    sectionNavigationClassList
  );

  return (
    <nav
      className={sectionNavigationClassName}
      id={sanitisedId}
      aria-labelledby={sanitisedHiddenTitleId}
      data-testid={`${sanitisedDataTestId}-section-menu`}
    >
      <h2
        className="ons-u-vh"
        id={sanitisedHiddenTitleId}
        data-testid={`${sanitisedDataTestId}-section-menu-nav-title`}
      >
        {props.hiddenTitle || "Pages in this section"}
      </h2>
      <ul
        className="ons-section-nav__list"
        data-testid={`${sanitisedDataTestId}-section-nav-list`}
      >
        {props.sections.map((item, index) => {
          // Ensures the NavLink component uses the same Router as the application the library is used in
          const LinkComponent = item.linkComponent;
          return (
            <li
              className={
                item.isActive
                  ? "ons-section-nav__item ons-section-nav__item--active"
                  : "ons-section-nav__item"
              }
              key={index}
              data-testid={`${sanitisedDataTestId}-section-nav-item-${index}`}
            >
              {item.isActive ? (
                <h3
                  className="ons-section-nav__link ons-section-nav__item-header"
                  aria-current="location"
                  data-testid={`${sanitisedDataTestId}-section-nav-item-header-${index}`}
                >
                  {item.title}
                </h3>
              ) : (
                <LinkComponent
                  to={item.url}
                  className="ons-section-nav__link"
                  data-testid={`${sanitisedDataTestId}-section-navlink-${index}`}
                >
                  {item.title}
                </LinkComponent>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
